import { change as reduxFormChangeAction, clearFields, registerField } from 'redux-form'
import { LKDate } from 'loankeeper-common/helpers/Date'
//@ts-ignore
import { actions as LKModalActions } from 'shared/LKModal'
import { translate, Storage } from 'loankeeper-common/helpers'
import { generatePrintPDFUrl, handlePrint } from '../shared/LKPrintButton'
import { accountSearchPost, accountViewBalance } from 'src/store/account'
import { accEntryViewByPage } from 'src/store/accEntry'
import { AppDispatch } from 'src/store/index.d'
import { checkReqFields } from 'src/store/client'

const pushDetailsRoute =
  (history) =>
  ({ OperTypeID, ID, EntryID, HashSum_EntryID_, OID, HashSum_OID_ }) => {
    let route

    if (OperTypeID === 6 || OperTypeID === 7) {
      route = `/secure/order/${EntryID || ID}/details/${HashSum_EntryID_}/${OperTypeID}/${OID}/${HashSum_OID_}`
    } else {
      route = `/secure/order/${EntryID || ID}/details/${HashSum_EntryID_}/${OperTypeID}`
    }

    history.push(route)
  }

export const translateWebMessage = (name) => translate(`frm_web_messages-${name}`)

export const printReport = async ({
  dispatch,
  page,
  printOption,
  EntryID,
  HashSum_EntryID_,
  OID,
  HashSum_OID_,
  OperTypeID,
  history,
  isCheckLoan,
}) => {
  if (printOption === '1' || printOption === '2') {
    const isConvert = OperTypeID === 6 || OperTypeID === 7

    let report
    try {
      const accResult = await dispatch(
        accEntryViewByPage({
          page,
          EntryID,
          HashSum_EntryID_,
          OID,
          HashSum_OID_,
          OperTypeID,
        }),
      )
      let reportData = accResult.payload

      if (accEntryViewByPage.fulfilled.match(accResult)) {
        if (reportData.length > 0) {
          if (isCheckLoan) {
            report = reportData.filter((r) => r.DFLoan === 1)
            if (report && report.length > 1) {
              reportData = report
            }
          } else {
            report = reportData.filter((r) => r.DFLoan === 2)
            if (report && report.length > 1) {
              reportData = report
            }
          }

          if (!report || report.length !== 1) {
            report = reportData.filter((r) => r.DFRP === 1)
            if (report && report.length > 1) {
              reportData = report
            }
          }

          if (!report || report.length !== 1) {
            report = reportData.filter((r) => r.DF === 1)
            if (report && report.length > 1) {
              reportData = report
            }
          }

          if (!report || report.length === 0) [report] = reportData
          else if (report && report.length === 1) [report] = report

          const url = await dispatch(
            generatePrintPDFUrl(isConvert ? 'entryConvert' : 'entry', {
              ID: isConvert ? OID : EntryID,
              hash: isConvert ? HashSum_OID_ : HashSum_EntryID_,
              PrintReportID: report.ID,
              printReportHash: isConvert ? report.HashSum_PrintReportIDOID_ : report.HashSum_PrintReportIDEntryID_,
              page,
              direct: printOption === '1',
              HashSum_PrintReportIDOID_: reportData[0].HashSum_PrintReportIDOID_,
            }),
          )

          if (url) {
            const printResult = await handlePrint(url, printOption === '1')

            if (!printResult) {
              const urlPDF = await dispatch(
                generatePrintPDFUrl(isConvert ? 'entryConvert' : 'entry', {
                  ID: isConvert ? OID : EntryID,
                  hash: isConvert ? HashSum_OID_ : HashSum_EntryID_,
                  PrintReportID: report.ID,
                  printReportHash: isConvert ? report.HashSum_PrintReportIDOID_ : report.HashSum_PrintReportIDEntryID_,
                  page,
                  direct: false, // Generate  PDF to view printing is getting fail
                  HashSum_PrintReportIDOID_: reportData[0].HashSum_PrintReportIDOID_,
                }),
              )

              handlePrint(urlPDF, false) // View PDF
            }
          }
        }
      } else {
        throw reportData
      }
    } catch (e) {
      dispatch(
        LKModalActions.openError(e.code === 5 ? translateWebMessage('ERR_PRINT_SERVICE_UNAVAILABLE') : e.message),
      )
    }
  } else if (printOption === '3') {
    //@ts-ignore
    pushDetailsRoute(history)({ OperTypeID, EntryID, HashSum_EntryID_, OID, HashSum_OID_ })
  }
}

export const isRequired = (field) => field && field.Active === 1

export const searchAccounts = ({ dispatch, fetcherName, accountID, ccyName, page }) => {
  return dispatch(
    // fetchSFM({
    //   instanceName: fetcherName,
    //   callApi: Account.search,
    //   callApiArgs: [{ accno: accountID, statusid: 2, ccy: ccyName, page }],
    // }),
    //UPDATED API REQUEST 'acc_account_search'
    accountSearchPost({
      AccNo: accountID,
      StatusID: 2,
      CCY: ccyName,
      Page: page,
      instanceName: fetcherName,
    }),
  )
}

export const searchAccountAndInitialize = ({
  dispatch,
  fetcherName,
  accountNo,
  accountCredentials,
  FormName,
  ccyName,
}) =>
  searchAccounts({ dispatch, fetcherName, accountID: accountNo, ccyName, page: 'searchexact' })
    .then(({ payload }) => {
      const Data = payload.data
      if (Data.length === 1) {
        const { ID, HashSum_AccountID_, TitleUNI, TypeID, SecLevel } = Data[0]

        dispatch(reduxFormChangeAction(FormName, accountCredentials.accID, ID))
        dispatch(reduxFormChangeAction(FormName, accountCredentials.accHash, HashSum_AccountID_))
        dispatch(reduxFormChangeAction(FormName, accountCredentials.chosenAccNo, accountNo))
        dispatch(reduxFormChangeAction(FormName, accountCredentials.accTitle, TitleUNI))
        dispatch(reduxFormChangeAction(FormName, 'chosenAccountTypeID', TypeID)) // to check if money transfer section is visible

        if (TypeID === 9) {
          dispatch(registerField(FormName, 'MoneyTransferCountryID', 'Field'))
          dispatch(registerField(FormName, 'MoneyTransferSystemID', 'Field'))
          dispatch(registerField(FormName, 'MoneyTransferCode', 'Field'))
          dispatch(registerField(FormName, 'MoneyTransferAgent', 'Field'))
        }

        if (parseInt(Data[0].AccNo, 10) !== accountNo) {
          dispatch(reduxFormChangeAction(FormName, accountCredentials.accNo, Data[0].AccNo))
        }

        return {
          SecLevel,
          ID,
          TitleUNI,
          HashSum_AccountID_,
        }
      }

      dispatch(reduxFormChangeAction(FormName, accountCredentials.accTitle, 'ACCOUNT_NOT_FOUND'))
      throw new Error('ACCOUNT_NOT_FOUND')
    })
    .then(async (data) => {
      const { ID: AccountID, HashSum_AccountID_ } = data
      const balanceResult = await dispatch(
        accountViewBalance({
          AccountID,
          HashSum_AccountID_,
        }),
      )

      if (accountViewBalance.fulfilled.match(balanceResult)) {
        const {
          payload: { Balance: balance },
        } = balanceResult

        dispatch(reduxFormChangeAction(FormName, accountCredentials.accBalance, balance))

        return balance
      }
    })
    .catch((error) => {
      if (error.message === 'ACCOUNT_NOT_FOUND' || (error.Error && error.Error.Message === 'ERR_ACCOUNT_NOT_FOUND')) {
        dispatch(
          clearFields(
            FormName,
            false,
            false,
            accountCredentials.accID,
            accountCredentials.accHash,
            accountCredentials.accTitle,
            accountCredentials.accBalance,
            accountCredentials.chosenAccNo,
            'chosenAccountTypeID',
          ),
        )

        throw new Error('ERR_ACCOUNT_NOT_FOUND')
      }
    })

export const checkRequiredFields = (change, form, Data, openClientEditConfirmation, dispatch: AppDispatch) => {
  // return Client.checkReqFields({
  //   ClientID: Data.ID,
  //   HashSum_ClientID_: Data.HashSum_ClientID_,
  //   ID: 9,
  // })
  //   .then((response) => {
  //     if (response.Data && !response.Data.length) {
  //       if (Data.Watched === 1) {
  //         change('clientWatched', 1)
  //       }

  //       change('clientIsChosen', true)
  //       change('clientType', Data.ClientTypeID)
  //       change('clientID', Data.ID)
  //       change('clientHash', Data.HashSum_ClientID_)
  //       change('Name', Data.FName)
  //       change('Surname', Data.LName)
  //       change('CityID', Data.CityID)
  //       change('Address', Data.Address)
  //       change('IDCardTypeID', Data.IDCardTypeID)
  //       change('IDCardTypeInit', Data.IDCardTypeID)
  //       change('IDCardIssuerID', Data.IDCardIssuerID)
  //       change('FullName', Data.FullName)
  //       change('DOB', LKDate.from(Data.DOB).toString())
  //       change('CardNumber', Data.CardNumber)
  //       change('IDCardRegDate', LKDate.from(Data.IDCardRegDate).toString())
  //       change('CellPhone', Data.CellPhone)
  //       change('OtherIDNumber', Data.IDSerial)
  //       change('IDValidityDate', LKDate.from(Data.IDValidityDate).toString())
  //       change('CitizenshipID', Data.CitizenshipID)
  //       change('CardNumberSearch', Data.CardNumber)
  //       change('Client', Data)

  //       change('IDCardRegDateCheck', '1')
  //       if (Data.IDValidityDate === '1900-01-01 00:00:00') change('IDValidityDateCheck', '0')
  //       else change('IDValidityDateCheck', '1')
  //       change('DOBCheck', '1')

  //       return Data
  //     }

  //     throw new Error('CLIENT_NOT_VALID')
  //   })
  //   .catch((error) => {
  //     if (error.message === 'CLIENT_NOT_VALID') {
  //       openClientEditConfirmation({
  //         ID: Data.ID,
  //         hash: Data.HashSum_ClientID_,
  //         ClientType: 1,
  //         clientReqFieldGroupID: 9,
  //       })

  //       throw new Error('CLIENT_NOT_VALID')
  //     }
  //   })

  //UPDATED API REQUEST client_oper_api page: checkreqfields
  return dispatch(
    checkReqFields({
      ClientID: Data.ID,
      HashSum_ClientID_: Data.HashSum_ClientID_,
      ID: 9,
    }),
  )
    .then((res) => {
      const response = { Data: res.payload }
      if (response.Data && !response.Data.length) {
        if (Data.Watched === 1) {
          change('clientWatched', 1)
        }

        change('clientIsChosen', true)
        change('clientType', Data.ClientTypeID)
        change('clientID', Data.ID)
        change('clientHash', Data.HashSum_ClientID_)
        change('Name', Data.FName)
        change('Surname', Data.LName)
        change('CityID', Data.CityID)
        change('Address', Data.Address)
        change('IDCardTypeID', Data.IDCardTypeID)
        change('IDCardTypeInit', Data.IDCardTypeID)
        change('IDCardIssuerID', Data.IDCardIssuerID)
        change('FullName', Data.FullName)
        change('DOB', LKDate.from(Data.DOB).toString())
        change('CardNumber', Data.CardNumber)
        change('IDCardRegDate', LKDate.from(Data.IDCardRegDate).toString())
        change('CellPhone', Data.CellPhone)
        change('OtherIDNumber', Data.IDSerial)
        change('IDValidityDate', LKDate.from(Data.IDValidityDate).toString())
        change('CitizenshipID', Data.CitizenshipID)
        change('CardNumberSearch', Data.CardNumber)
        change('Client', Data)

        change('IDCardRegDateCheck', '1')
        if (Data.IDValidityDate === '1900-01-01 00:00:00') change('IDValidityDateCheck', '0')
        else change('IDValidityDateCheck', '1')
        change('DOBCheck', '1')

        return Data
      }

      throw new Error('CLIENT_NOT_VALID')
    })
    .catch((error) => {
      if (error.message === 'CLIENT_NOT_VALID') {
        openClientEditConfirmation({
          ID: Data.ID,
          hash: Data.HashSum_ClientID_,
          ClientType: 1,
          clientReqFieldGroupID: 9,
        })

        throw new Error('CLIENT_NOT_VALID')
      }
    })
}

export const getCommercialRateInfo = (rates, debitCCY, creditCCY) =>
  rates.find((rate) => rate.CCY === debitCCY && rate.CCY2 === creditCCY)

const ORDER_ADD_FLAGS_STORAGE_KEY = 'orderAddFlags'

export function setOrderAddFlags(state) {
  Storage.set(ORDER_ADD_FLAGS_STORAGE_KEY, state)
}

export function getOrderAddFlags(form) {
  let state = Storage.get(ORDER_ADD_FLAGS_STORAGE_KEY)

  if (typeof state !== 'object' || !state) {
    state = {
      [form]: {},
    }

    setOrderAddFlags(state)
    return state
  }

  if (typeof state[form] !== 'object') {
    state = {
      ...state,
      [form]: {},
    }

    setOrderAddFlags(state)
    return state
  }

  return state
}
